/**
 * G-9.2 kit: a `Chip` carrying the colour it names.
 *
 * Composed from two pieces that already exist rather than restyled from
 * scratch — `.kit-chip` for the pill (so the selected state stays the kit's
 * accent-soft fill, with full accent fill reserved for primary buttons) and
 * `.sf-color-dot` for the swatch, the same atom the floor builder's colour
 * filter uses.
 *
 * `hex` is null for non-visual colours like "Mixed" (`Color.hex`). Those get a
 * dashed pill and an empty dashed dot: inventing a grey circle would state a
 * colour the catalogue does not have.
 */
export function ColorChip({
  name,
  hex,
  selected,
  onToggle,
  disabled = false,
}: {
  name: string;
  hex: string | null;
  selected: boolean;
  onToggle: () => void;
  disabled?: boolean;
}) {
  const className = [
    "kit-chip",
    "kit-color-chip",
    selected ? "is-selected" : "",
    hex ? "" : "kit-color-chip--unknown",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={className}
      aria-pressed={selected}
      onClick={onToggle}
      disabled={disabled}
    >
      <span
        className={
          hex ? "sf-color-dot" : "sf-color-dot kit-color-swatch--unknown"
        }
        style={hex ? { background: hex } : undefined}
        aria-hidden="true"
      />
      {name}
      {selected ? (
        <span className="kit-color-chip-check" aria-hidden="true">
          ✓
        </span>
      ) : null}
    </button>
  );
}
